import React from 'react';

import * as Connector from 'paths-js/connector';

import './PackageEditor.css'
import AppContent from '../_Shared/Layout/AppContent';
import PackageEditorWorkspace from './PackageEditorWorkspace';
import PackageEditorToolbar from './PackageEditorToolbar';
import PackageEditorQuery from './PackageEditorQuery';
import PackageQueryEditor from './PackageQueryEditor';
import PackageExecutionHistory from './PackageExecutionHistory';

const uuidv4 = require('uuid/v4');
const _ = require('lodash');

class PackageEditor extends React.Component {

    constructor(props) {
        super(props);

        // window.addEventListener('keydown', e => {
        //     if (e.altKey) {
        //         e.preventDefault();
        //         this.setState({ queryActionClass: 'move' });
        //         return;
        //     }
        // });

        // window.addEventListener('keyup', () => {
        //     this.setState({ queryActionClass: null, actionClass: null });
        // });

        this.state = {
            etlPackage: { queries: [], objects: [], matrix: [1, 0, 0, 1, 0, 0], scale: 1 },
            selectedQueries: [],
            insertMode: null,
            queryEditor: null,
            executionHistory: false,
            isUpdate: false,
            parentQueries: []
        };
    }

    componentDidUpdate(prevProps, prevState) {
        const { etlPackage } = this.props;
        if (etlPackage !== null && !_.isEqual(prevProps.etlPackage, etlPackage)) {
            this.setState({ etlPackage });
        }
    }

    componentWillUnmount() {
        alert('fix');
    }

    //Creates a self updating connector based on parent location
    generateCurvePath = (query, join) => {
        const { etlPackage: { queries } } = this.state;
        let parent = queries.find(x => x.id === join);

        if (parent !== null && parent !== undefined) {
            var path = {
                start: [parent.x + 14, parent.y + 14],
                end: [query.x + 14, query.y + 14]
            }

            if (path.start[0] === path.end[0] || path.start[1] === path.end[1]) {
                return `M ${path.start[0]} ${path.start[1]} ${path.end[0]} ${path.end[1]}`;
            }

            var connector = Connector(path);
            return connector.path.print();
        }

        return '';
    }

    generateInsertPoint = (query, join, key) => {
        const { etlPackage: { queries }, selectedQueries } = this.state;
        let selected = selectedQueries.find(x => x.id === query.id || x.id === join);
        if (selected) return '';
        let parent = queries.find(x => x.id === join);

        if (parent !== null && parent !== undefined) {
            return <rect x={parent.x + (query.x - parent.x) / 2} y={parent.y + (query.y - parent.y) / 2}
                style={{ cursor: 'pointer' }} onClick={() => this.insertQuery(parent, query)} fill="rgba(230,230,230,.8)" width="28px" height="28px" />
        }

        return ''
    }

    //Refactored Mouse events - moved Query Object into component and handled movement directly from component - removes requirement of type checking listeners
    updateQueryLocation = (id, x, y) => {
        const { etlPackage: { queries, scale, ...rest } } = this.state;

        this.setState({
            etlPackage: Object.assign({}, {
                queries:
                    [...queries.map(query => (query.id === id) ?
                        Object.assign({}, query, {
                            x: query.x + Math.round(x / scale), y: query.y + Math.round(y / scale)
                        }) : query
                    )], scale, ...rest
            })
        });
    }

    updateObject = obj => {
        const { etlPackage: { objects, ...rest } } = this.state;
        this.setState({
            etlPackage: Object.assign({}, { objects: [...objects.filter(o => o.id !== obj.id), obj], ...rest })
        });
    }

    createQuery = query => {
        const { etlPackage: { queries, ...rest } } = this.state;

        let parents = queries.filter(x => query.parent_ids.includes(x.id)).map(x => ({...x, Selected: false}));
debugger;
        this.setState({
            etlPackage: Object.assign({}, { queries: [...queries, query], ...rest }),
            selectedQueries: [],
            queryEditor: query,
            isUpdate: false,
            parentQueries: parents
        });
    }

    insertQuery = (parent, query) => {
        const { etlPackage: { queries, ...rest }, selectedQueries } = this.state;
        let newQuery = {
            x: parent.x + (query.x - parent.x) / 2,
            y: parent.y + (query.y - parent.y) / 2,
            id: uuidv4(),
            parent_ids: [...selectedQueries.map(x => x.id), parent.id],
            icon: selectedQueries.length > 0 ? 'datajoin' : 'default'
        };
        query.parent_ids = [...query.parent_ids.filter(x => x !== parent.id), newQuery.id];
        this.setState({
            etlPackage: Object.assign({}, { queries: [...queries.filter(x => x.id !== query.id), newQuery, query], ...rest }),
            queryEditor: query,
            selectedQueries: [],
            insertMode: null
        });
    }

    selectQuery = query => {
        let { selectedQueries } = this.state;
        let index = selectedQueries.findIndex(x => x.id === query.id)

        if (index > -1) { selectedQueries.splice(index, 1); }
        else { selectedQueries.push(query); }

        this.setState({ selectedQuery: selectedQueries });
    }

    editQuery = () => {
        const { selectedQueries, etlPackage: { queries } } = this.state;

        let parents = queries.filter(x => selectedQueries[0].parent_ids.includes(x.id));
        //let parents = queries.filter(x => selectedQueries[0].parent_ids.includes(x.id)).map(x => ({...x, columns: [] }));
//debugger;
        this.setState({ 
            queryEditor: selectedQueries[0], 
            isUpdate: true,
            parentQueries: parents
        });
    }

    closeQueryEditor = query => {
        if (query !== null) { }
        this.setState({ queryEditor: null });
    }

    closeExecutionHistory = () => {
        this.setState((prevState) => {
            return { executionHistory: !prevState.executionHistory }
        });
    }

    toggleInsert = mode => {
        let { insertMode } = this.state;
        this.setState({ insertMode: insertMode === mode ? null : mode });
    }

    selectObject = obj => { }

    handleStateChange = partialState => {
        this.setState(partialState);
    }

    savePackage = () => {
        const { onSaveBatchEtlQueries } = this.props;
        const { etlPackage } = this.state;

        onSaveBatchEtlQueries(etlPackage.queries);
    }

    executePackage = () => {
        const { onPackageExecuted } = this.props;
        const { etlPackage: { id, executions } } = this.state;
        onPackageExecuted(Object.assign({}, {
            id: uuidv4().replace(/-/g, ''),
            order: executions.length,
            etlPackageId: id,
            status: 'pending',
            statusMessage: 'Steps currently processing',
            steps: [{ queryId: '0', status: 'pending', statusMessage: 'Currently processing' }]
        }));
    }

    executionHistory = () => {
        this.setState({ executionHistory: true });
    }

    saveQuery = (query) => {
        const { onSaveEtlQuery, onEditEtlQuery } = this.props;
        const { isUpdate } = this.state;

        if (!isUpdate) { onSaveEtlQuery(query); }
        else { onEditEtlQuery(query); }

        this.setState({ selectedQueries: [] });
    }

    deleteQuery = () => {
        const { onDeleteEtlQuery } = this.props;
        const { selectedQueries } = this.state;
        onDeleteEtlQuery(selectedQueries[0]);
    }

    render() {
        const { etlPackage: { id, queries, objects, matrix, scale, name, executions }, queryActionClass, insertMode, selectedQueries, queryEditor,
            executionHistory, parentQueries } = this.state;
        return (
            <AppContent>
                <PackageEditorToolbar title={name} onToggleInsertMode={this.toggleInsert} onSavePackage={this.savePackage}
                    onExecutePackage={this.executePackage} onExecutionHistory={this.executionHistory} insertMode={insertMode}
                    selectedQueries={selectedQueries} editQuery={this.editQuery} deleteQuery={this.deleteQuery} />
                <PackageEditorWorkspace insertMode={insertMode} onCreateQuery={this.createQuery} onPanZoom={this.handleStateChange}
                    onUpdateObject={this.updateObject} onCallback={this.handleStateChange} matrix={matrix} scale={scale}
                    selectedQueries={selectedQueries} etlPackageId={id}>
                    {
                        [].concat(objects).map((obj, key) =>
                            <rect key={key} x={obj.x} y={obj.y} width={obj.w} height={obj.h} onClick={() => this.selectObject(obj)}
                                strokeWidth="1" fill="white" stroke="#000" />
                        )
                    }
                    {
                        [].concat(queries).map((query, s) =>
                            query.parent_ids.map((join, x) => <g key={`c_${s}_${x}`}>
                                <path d={this.generateCurvePath(query, join)} stroke="#1E1935" strokeWidth="2" fill="none" />
                                {
                                    (insertMode === 'query') && this.generateInsertPoint(query, join)
                                }
                            </g>
                            )
                        )
                    }
                    {
                        [].concat(queries).map((query, s) => {
                            let selected = selectedQueries.find(x => x.id === query.id);
                            return <PackageEditorQuery key={s} queryActionClass={queryActionClass} query={query} onMove={this.updateQueryLocation} onClick={this.selectQuery} selected={selected} />
                        })
                    }
                </PackageEditorWorkspace>
                <PackageQueryEditor open={queryEditor !== null} query={queryEditor} parentQueries={parentQueries} onSaveQuery={this.saveQuery} onClose={this.closeQueryEditor} />
                <PackageExecutionHistory open={executionHistory} executions={executions} onClose={this.closeExecutionHistory} />
            </AppContent>
        )
    }
}

export default PackageEditor;


// WEBPACK FOOTER //
// ./src/Components/Presentation/ETL/PackageEditor.js